const list = state => state.glossary.list;
const article = state => state.glossary.article;

export default {
  list,
  article,
};
